import LinkCell from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/runner/components/cells/link_cell.vue?vue3';
export default {
    name: 'ProjectCell',
    components: {
        LinkCell
    },
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    computed: {
        projectName () {
            return this.job.pipeline?.project?.fullPath;
        },
        projectUrl () {
            return this.job.pipeline?.project?.webUrl;
        }
    }
};
